import React from "react";
import style from "./index.module.css";
import banner from "./image/banner.jpg";
import about from "./image/about.jpg";

function Home() {
  return (
    <>
      <div className={style.banner}>
        <img src={banner} alt="智融天下 稳健前行" />
      </div>
      <div className={style.content}>
        <article>
          <div>
            <article className={style.about}>
              <h3>关于我们</h3>
              <p>
                深圳市融达融资担保有限公司成立于2004年2月20日，以稳健性、安全性、
                规范性、合法性、流动性、效益性为准则，拥有一支高素质且富有经验的，
                由工商管理、金融、财务和法律等专业人士组成经营团队的专业性融资担保
                公司。拥有丰富的金融行业资源整合能力，是一家具备良好发展潜力和盈利
                能力的商业担保公司。
              </p>
              <ul>
                <li>
                  <div className={style.round}>10亿+</div>
                  <div className={style.detail}>注册资本</div>
                </li>
                <li>
                  <div className={style.round}>AA+</div>
                  <div className={style.detail}>信用评级</div>
                </li>
                <li>
                  <div className={style.round}>长期</div>
                  <div className={style.detail}>担保资质</div>
                </li>
              </ul>
            </article>
            <div className={style.imgbox}>
              <img src={about} alt="关于我们" title="深圳市融达融资担保有限公司" />
            </div>
          </div>
        </article>
        <article>
          <header>
            <span />
            <div>
              <h3>业务范围</h3>
              <h4>BUSINESS SCOPE</h4>
            </div>
            <span />
          </header>
          <ul className={style.business}>
            <li>
              <div className={style.pc1}>
                <span>融资性担保业务</span>
              </div>
              <p>
                贷款担保、票据承兑担保、贸易融资
                担保、项目融资担保、信用证担保等 融资业务.
              </p>
            </li>
            <li>
              <div className={style.pc2}>
                <span>非融资性担保</span>
              </div>
              <p>
                诉讼保全担保
                <br />
                履约担保等
              </p>
            </li>
            <li>
              <div className={style.pc3}>
                <span>其他业务</span>
              </div>
              <p>与担保有关的融资咨询财务顾问等</p>
            </li>
          </ul>
        </article>
      </div>
    </>
  );
}

export default Home;
